<template>
  <el-dialog title="发送消息" :visible.sync="visiable"  :close-on-click-modal="false" :close-on-press-escape="false" @close="handleCloseDialog">
    <message-form
      ref="messageDialogFormRef"
      :info="activeItem"
      isOther
      submit-url="system/message2/sandMessageNew"
      @refreshData="refreshDialogData"
    />
    <div slot="footer" class="dialog-footer">
      <el-button class="search-btn btn-gray" @click="handleCloseDialog">取消</el-button>
      <el-button class="search-btn btn-blue" @click="handleSend">发送</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MessageForm from "@/components/newMessage/components/messageForm.vue";

export default {
  name: "MessageDialog",
  components: {
    MessageForm,
  },
  props: {
    visiable: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      activeItem: {}
    };
  },
  watch: {
    info: {
      handler(val) {
        this.activeItem = {
          ...val,
          isOtherPageMessageTip: true,
        };
      },
      deep: true,
    },
  },
  methods: {
    handleSend() {
      // 回复框展开时的发送按钮
      this.$refs.messageDialogFormRef.submit();
    },
    handleCloseDialog() {
      this.$emit("update:visiable", false);
      this.$refs.messageDialogFormRef.formReset();
    },
    refreshDialogData() {
      this.handleCloseDialog();
      this.$emit("confirm");
    },
  },
};
</script>

<style scoped lang="less">
.text-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.under-text {
  text-decoration: underline;
  cursor: pointer;
}
.danger-text {
  color: #f56c6c;
}
.primary-text {
  color: #3e8ef7;
}
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.message-wrap {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 50px - 45px - 39px);
  color: #606266;
  ::v-deep .el-empty {
    width: 30%;
  }
  .message-search {
    background-color: #fff;
    padding: 15px;
    .search-form {
      display: flex;
      ::v-deep .el-form-item {
        margin-bottom: 0;
        display: flex;
        flex: 1;
      }
      ::v-deep .el-form-item__label {
        flex: none;
      }
      ::v-deep .el-form-item__content {
        flex: 1;
      }
      .max-picker {
        width: auto;
      }
      .custom-form-btn {
        min-width: 360px;
        text-align: right;
        margin-right: 0;
      }
    }
  }
  .message-content {
    flex: 1;
    display: flex;
    margin-top: 15px;
    overflow: hidden;
    .message-content-left {
      margin-right: 15px;
      width: 32%;
      flex: none;
      overflow-y: auto;
      .message-list {
        width: 100%;
        .message-list-item {
          width: 100%;
          background: #fff;
          border-radius: 5px;
          padding: 15px;
          margin-bottom: 15px;
          line-height: 28px;
          border: 1px solid transparent;
          cursor: pointer;
          position: relative;
          .text-cursor {
            cursor: pointer;
          }
          .message-info {
            cursor: pointer;
            display: flex;
            .html-content {
              overflow: hidden;
              height: 28px;
              max-width: 80%;
            }
          }
          .text-content {
            max-width: 80%;
          }
          .collect-icon {
            position: absolute;
            top: 8px;
            right: 8px;
            color: #595bb3;
            font-size: 20px;
          }
        }
        .active-item {
          border: 1px solid #3e8ef7;
        }
      }
    }
    .message-content-right {
      flex: 1;
      background-color: #fff;
      border-radius: 5px;
      padding: 15px;
      position: relative;
      overflow-y: auto;
      .send-message-wrap {
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.5s;
      }
      .reply {
        max-height: 800px;
        transition: max-height 0.5s;
      }
      .send-list-operate {
        position: absolute;
        top: 15px;
        right: 15px;
      }
      .message-list-item {
        border-bottom: 1px solid #ccc;
        h3 {
          font-size: 14px;
          margin: 10px 0;
        }
        .send-info {
          display: flex;
          background-color: #f2f2f2;
          line-height: 50px;
          gap: 35px;
          padding: 0 10px;
        }
        .rich-text-content {
          margin: 15px 0;
          ::v-deep img {
            max-width: 100%;
          }
        }
        .association {
          display: flex;
          gap: 35px;
        }
        .annex-list {
          width: 54%;
          .annex-list-item {
            display: flex;
            justify-content: space-between;
            height: 28px;
            .file-name {
              max-width: 70%;
            }
          }
        }
      }
    }
  }
}
</style>
